import { TOP, BOTTOM, LEFT, RIGHT, BEFORE, AFTER } from 'layout-dnd-utils/constants';

// Drag types
export const dragTypes = {
  EXISTING_ITEM: 'EXISTING_ITEM',
  RESIZE_HANDLE: 'RESIZE_HANDLE'
};

// Drop target types
export const dropTypes = {
  PREPEND_ROW: 'PREPEND_ROW',
  APPEND_ROW: 'APPEND_ROW',
  INSERT_COLUMN_AFTER: 'INSERT_COLUMN_AFTER',
  INSERT_COLUMN_BEFORE: 'INSERT_COLUMN_BEFORE',
  INSERT_INTO_EMPTY_ROW: 'INSERT_INTO_EMPTY_ROW',
  INSERT_INTO_EMPTY_COLUMN: 'INSERT_INTO_EMPTY_COLUMN',
  INSERT_ROW_AFTER: 'INSERT_ROW_AFTER',
  INSERT_ROW_BEFORE: 'INSERT_ROW_BEFORE',
  PREPEND_ELEMENT: 'PREPEND_ELEMENT',
  APPEND_ELEMENT: 'APPEND_ELEMENT',
  INSERT_ELEMENT_BEFORE: 'INSERT_ELEMENT_BEFORE',
  INSERT_ELEMENT_AFTER: 'INSERT_ELEMENT_AFTER',
  INSERT_INTO_EMPTY_HORIZONTAL_STACK: 'INSERT_INTO_EMPTY_HORIZONTAL_STACK',
  INSERT_INTO_EMPTY_VERTICAL_STACK: 'INSERT_INTO_EMPTY_VERTICAL_STACK',
  INSERT_SECTION_BEFORE: 'INSERT_SECTION_BEFORE',
  INSERT_SECTION_AFTER: 'INSERT_SECTION_AFTER',
  PREPEND_SECTION: 'PREPEND_SECTIION',
  APPEND_SECTION: 'APPEND_SECTION',
  INSERT_INTO_TABLE_CELL: 'INSERT_INTO_TABLE_CELL',
  APPEND_GRID_CELL: 'APPEND_GRID_CELL',
  INSERT_AFTER_TABLE_CELL: 'INSERT_AFTER_TABLE_CELL'
};
export const dropTargetOrientation = {
  HORIZONTAL: 'HORIZONTAL',
  VERTICAL: 'VERTICAL'
};
export const dropTargetLocations = {
  TOP,
  BOTTOM,
  LEFT,
  RIGHT,
  BEFORE,
  AFTER,
  INSIDE: 'INSIDE',
  SPLIT_ROW_BEFORE: 'SPLIT_ROW_BEFORE',
  SPLIT_ROW_AFTER: 'SPLIT_ROW_AFTER'
};

// Resize handle types
export const resizeHandleTypes = {
  RESIZE_HANDLE_LEFT: 'RESIZE_HANDLE_LEFT',
  RESIZE_HANDLE_RIGHT: 'RESIZE_HANDLE_RIGHT',
  RESIZE_HANDLE_BETWEEN: 'RESIZE_HANDLE_BETWEEN'
};

// Resize handle dimensions
export const resizeHandleDimensions = {
  HEIGHT_SCALE: 0.8,
  WIDTH: 10
};
export const MODULE_DRAG_HANDLE = 'MODULE_DRAG_HANDLE';
export const EMPTY_CONTAINER_DRAG_HANDLE = 'EMPTY_CONTAINER_DRAG_HANDLE';
export const COLUMN_DRAG_HANDLE = 'COLUMN_DRAG_HANDLE';
export const ROW_DRAG_HANDLE = 'ROW_DRAG_HANDLE';
export const SECTION_DRAG_HANDLE = 'SECTION_DRAG_HANDLE';
export const INSERT_NEW_SECTION_HANDLE = 'INSERT_NEW_SECTION_HANDLE';
export const TABLE_DRAG_HANDLE = 'TABLE_DRAG_HANDLE';
export const OFFSCREEN_POSITION = {
  TOP: -1000,
  LEFT: -1000
};
export const DRAG_PREVIEW_HEIGHT_PX = 80;
export const DRAG_PREVIEW_WIDTH_PX = 80;
export const SCROLL_DURING_DRAG_AMOUNT = 50;

// Node position config keys
export const GLOBAL_GROUPS_CONFIG = 'GLOBAL_GROUPS_CONFIG';
export const GLOBAL_PARTIALS_CONFIG = 'GLOBAL_PARTIALS_CONFIG';
export const STATIC_MODULES_CONFIG = 'STATIC_MODULES_CONFIG';
export const POST_BODY_MODULES_CONFIG = 'POST_BODY_MODULES_CONFIG';
export const FLEX_COLUMN_MODULES_CONFIG = 'FLEX_COLUMN_MODULES_CONFIG';
export const NESTED_MODULES_IN_RTE_CONFIG = 'NESTED_MODULES_IN_RTE_CONFIG';
export const LAYOUT_SECTIONS_CONFIG = 'LAYOUT_SECTIONS_CONFIG';
export const GRID_LAYOUTS_NODE_POSITION_CONFIG = 'GRID_LAYOUTS_NODE_POSITION_CONFIG';
export const ALL_NODE_POSITION_CONFIG_KEYS = [GLOBAL_GROUPS_CONFIG, GLOBAL_PARTIALS_CONFIG, STATIC_MODULES_CONFIG, FLEX_COLUMN_MODULES_CONFIG, LAYOUT_SECTIONS_CONFIG, POST_BODY_MODULES_CONFIG, NESTED_MODULES_IN_RTE_CONFIG, GRID_LAYOUTS_NODE_POSITION_CONFIG];
export const RESIZE_HANDLE_LEFT = 'RESIZE_HANDLE_LEFT';
export const RESIZE_HANDLE_RIGHT = 'RESIZE_HANDLE_RIGHT';